module.exports = __webpack_public_path__ + "static/media/banner.55517600.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/banner.png
// module id = 646
// module chunks = 0